module.exports = __webpack_public_path__ + "static/img/002城市名片1.c2ce397.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/002城市名片1.jpg
// module id = Wxvy
// module chunks = 0